import { Container, PoweredByLabel } from "./Styled";
import { Logo } from "../GeneralStyles/GeneralStyles";
import VerbitLogo from "../../assets/Logo.webp";
import { useWhiteLabelingConfig } from "../../hooks/useWhiteLabelingConfig";

const Header = () => {
  const config = useWhiteLabelingConfig();
  const logoSrc = config ? (config.logosFullSize?.light || VerbitLogo) : null;
  // HUB 1: Verbit logo image label
  const logoLabel = `${config?.customerLabel || "Verbit"} logo`;

  return (
    <Container>
      {logoSrc && (
        <Logo
          src={logoSrc}
          alt={logoLabel}
        />
      )}
      {config?.shouldShowPoweredBy && (
        <PoweredByLabel>Powered by Verbit</PoweredByLabel>
      )}
    </Container>
  );
};

export default Header;
